import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useTable, useSortBy, CellProps } from 'react-table';
import serachIcon from "../../../../images/search-gray.svg";
import CombinedShape from '../../../../images/three-dots-vertical.svg';
import activeCombinedShape from '../../../../images/active-CombinedShape.svg'
import {ReactComponent as LocalIcon} from "../../../../images/localIcon.svg"
import {ReactComponent as GlobalIcon} from "../../../../images/globalIcon.svg"
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import {
  faSortDown,
  faSortUp,
  faUnsorted,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import '../AdminPricingSettings.scss'
import DeleteTemplateModal from '../PricingTabs/TieredPricing/DeleteTemplateModal';
import { PricingTemplateData, SelectedStructure } from '../../../../models/AdminSettingsM/AdminPricingSettingsModel';
import SaveTemplateForm from '../PricingTabs/TieredPricing/SaveTemplateForm';
import Service from '../../../../services';
import { BankUserContext } from '../../../../bankUserContext';
import { catchError } from '../../../../utils/Utils';

interface IpricingTemplate{
  pricingTemplateHandler:Function;
  editHandler:Function;
  selectedpricingStructure?:SelectedStructure;
  message:Function;
}

const PricingTemplate = (props:IpricingTemplate) => {
  const {pricingTemplateHandler,selectedpricingStructure,message} = props
  const [dropdownToggle, setDropdownToggle] = useState<number>();
  const [activeTab, setActiveTab] = useState(0);
  const [saveToggle,setSaveToggle] = useState<boolean>(false)
  const [open,setOpen] = useState<boolean>(false)
  const [tableData, setTableData] =  useState<
  PricingTemplateData[]
>([]);
  const service = new Service();
  const context = useContext(BankUserContext);
  
  const openToggle = (index: number) => {
    if (index === dropdownToggle) {
      setDropdownToggle(-1);

    } else {
      setDropdownToggle(index);
    }
  };

  const deleteModal = () =>{
    setOpen(!open)
  }

 ;



  const getPricingTemplate = () => {
    const payload = {
      "screen": "PricingSettings",
      "sections": "getPricingTemplatesListByOrgProductId",
      orgId: context.bankuserDetails?.organization?.orgId,
      isJsonReturnObject: false,
    };
    service
      .getOrgProductsByPricingOption(payload)
      .then((res) => {
        console.log("tabeldata",res?.data);
        setTableData(res?.data);
      })
      .catch((err) => catchError(err, true));
  };
  useEffect(() => {
    getPricingTemplate();
  }, []);


  const columns = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Date Created',
        accessor: 'dateCreated',
      },
      {
        Header: 'Last Updated',
        accessor: 'lastUpdated',
      },
      {
        Header: 'Last Used',
        accessor: 'lastUsed',
      },
      {
        Header: 'Description',
        accessor: 'description',
        disableSortBy: true,
      },
      {
        Header: 'Type',
        accessor: 'type',
        Cell: ({ cell }: any) => (
          <>
          <div className="actions">
            <div className={`type-badge ${cell.value.toLowerCase()}`}>
              {cell.value === "Local" ? <LocalIcon/> : <GlobalIcon/>}
              <span>{cell.value} </span>
              </div>
          </div>
          </>
        ),
      },
      {
        Header:'',
        accessor:'dropdown',
        disableSortBy: true,
      }
    ],
    []
  );

  const handleEdit = (index: number) => {
    pricingTemplateHandler(selectedpricingStructure,true)
    console.log('Edit', index);
  };

  const handleDuplicate = (index: number) => {
    message('duplicate')
    console.log('Duplicate', index);
  };

  const handleDelete = (template: PricingTemplateData) => {
    message('delete')
    deleteModal()
  };

  const dropDown = (index:number)=>{
    return(
      <Dropdown isOpen={index === dropdownToggle} toggle={() => openToggle(index)} className="three-dots">
         <DropdownToggle data-toggle="dropdown" tag="span">
         {dropdownToggle===index? <img src={activeCombinedShape} className="combinedIcon" alt="serachIcon" />:<img src={CombinedShape} className="combinedIcon" alt="serachIcon" />}
          </DropdownToggle>
        <DropdownMenu className="three-dots-Options tableDropdown">
          <DropdownItem  className="edit-item" onClick={()=>handleEdit(index)}>Edit</DropdownItem>
          <DropdownItem className="edit-item" onClick={()=>handleDuplicate(index)}>Duplicate</DropdownItem>
          <DropdownItem onClick={()=>deleteModal()} className="delete-item">Delete</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    )
  }

  // const tableData: PricingTemplateData[] = [
  //   {
  //     name: 'Template Name Here',
  //     dateCreated: '1/04/2023',
  //     lastUpdated: '12/04/2023',
  //     lastUsed: '12/04/2023',
  //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed dote',
  //     type: 'Local',
  //   },
  //   {
  //     name: 'Template Name Here',
  //     dateCreated: '2/04/2023',
  //     lastUpdated: '12/04/2023',
  //     lastUsed: '12/04/2023',
  //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed dote',
  //     type: 'Global',
  //   },
  //   {
  //     name: 'Template Name Here',
  //     dateCreated: '03/04/2023',
  //     lastUpdated: '12/04/2023',
  //     lastUsed: '12/04/2023',
  //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed dote',
  //     type: 'Local',
  //   },
  //   {
  //     name: 'Template Name Here',
  //     dateCreated: '04/04/2023',
  //     lastUpdated: '12/04/2023',
  //     lastUsed: '12/04/2023',
  //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed dote',
  //     type: 'Local',
  //   },
  //   {
  //     name: 'Template Name Here',
  //     dateCreated: '05/04/2023',
  //     lastUpdated: '12/04/2023',
  //     lastUsed: '12/04/2023',
  //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed dote',
  //     type: 'Local',
  //   },
  //   {
  //     name: 'Template Name Here',
  //     dateCreated: '06/04/2023',
  //     lastUpdated: '12/04/2023',
  //     lastUsed: '12/04/2023',
  //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed dote',
  //     type: 'Global',
  //   },
  //   {
  //     name: 'Template Name Here',
  //     dateCreated: '07/04/2023',
  //     lastUpdated: '12/04/2023',
  //     lastUsed: '12/04/2023',
  //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed dote',
  //     type: 'Local',
  //   }, {
  //     name: 'Template Name Here',
  //     dateCreated: '08/04/2023',
  //     lastUpdated: '12/04/2023',
  //     lastUsed: '12/04/2023',
  //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed dote',
  //     type: 'Local',
  //   },
  // ];

  const data: any[] = React.useMemo(() => 
    tableData.map((item: any, index: number) => ({
      name: item?.name  ? `${item.name}` : "--",
      dateCreated: item.dateCreated,
      lastUpdated: item.lastUpdated || "- -",
      lastUsed: item.lastUsed || "- -",
      description: item.description ?item?.description : "- -",
      type: item.type,
      dropdown: dropDown(index),
    })), [dropdownToggle]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data }, useSortBy);
  const excludeSortIconsForColumns = ['description', 'dropdown'];

  return (
    <div className="pricing-template-table">
      <div className="topContainer">
        <p className="pricingHeader">Pricing Templates</p>
        <div className="rightContainer">
          <button className="create-button" onClick={()=>pricingTemplateHandler(selectedpricingStructure)}>Create New Template</button>
          <div className="searchContainer">
            <img src={serachIcon} className="searchIcon" alt="serachIcon" />
            <input type="text" placeholder="Search for Template" className="search-input" />
          </div>
        </div>
      </div>
       <table {...getTableProps()}>
        <thead>
          {headerGroups?.map((headerGroup: any, index: number) => (
              <tr {...headerGroup?.getHeaderGroupProps()} key={index}>
                {headerGroup?.headers?.map(
                  (column: any, columnIndex: number) => (
                    <th
                      key={columnIndex}
                      {...column?.getHeaderProps(
                        column?.getSortByToggleProps()
                      )}
                      style={{
                        background: "aliceblue",
                        color: "black",
                        fontWeight: "bold",
                      }}
                      className={column?.id}
                    >
                      <div
                        className="sortnigColumnDiv"
                      >
                        <span className="pointer-cursor">
                          {column?.render("Header")}{" "}
                        </span>
                        {!excludeSortIconsForColumns.includes(column?.id) && (<span>
                          <FontAwesomeIcon icon={faUnsorted} />
                          {column?.isSorted ? (
                            column?.isSortedDesc ? (
                              <FontAwesomeIcon icon={faSortUp} />
                            ) : (
                              <FontAwesomeIcon icon={faSortDown} />
                            )
                          ) : (
                            ""
                          )}
                        </span>)}
                      </div>
                    </th>
                  )
                )}
              </tr>
            ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row: any,index:number) => {
            prepareRow(row);
            return (
              <tr className={`${dropdownToggle===row.index?"InActiveRow":"activeRow"}`} {...row.getRowProps()}>
                {row.cells.map((cell: any) => (
                  <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      <DeleteTemplateModal
        cancelHandler={deleteModal}
        deleteHandler={handleDelete}
        className={"deleteTemplateModal"}
        modalToggle={deleteModal}
        confirmCloseModel={open}
      />
   
    </div>
  );
};

export default PricingTemplate;
